/**
 * Thin wrapper around @zg-rentals/log-error kept so ported HALO files retain
 * their original import path. Reports to Splunk, Marlin, and Dragnet.
 */

import { logError as reportError } from '@zg-rentals/log-error';

export type LogErrorPayload = {
  error: unknown;
  context?: Record<string, unknown>;
};

export function logError(payload: LogErrorPayload): void {
  reportError(payload);
}
